import React from "react";
import "./SettingsNewInfoMainbox.css";

function InfoMainbox() {
  return <div className="settingsnewinfomainbox"></div>;
}

export default InfoMainbox;
